import React from 'react';

const RetryIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="1 4 1 10 7 10"/>
    <path d="M3.51 15a9 9 0 1 0 .49-4.5"/>
  </svg>
);

/* Official brand SVG paths sourced from Simple Icons (simpleicons.org) */
const SOCIAL_META = {
  youtube: {
    label: 'YouTube',
    color: '#ff0000',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        {/* YouTube wordmark icon */}
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
  instagram: {
    label: 'Instagram',
    color: '#e1306c',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12c0 3.259.014 3.668.072 4.948.132 1.277.333 2.147.63 2.912.306.789.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.765.297 1.635.499 2.912.63C8.333 23.988 8.74 24 12 24c3.259 0 3.668-.014 4.948-.072 1.277-.132 2.148-.333 2.913-.63.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.635.63-2.912.057-1.28.072-1.689.072-4.948 0-3.259-.015-3.667-.072-4.947-.132-1.277-.334-2.148-.63-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.63C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06zm0 3.678a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 0 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"/>
      </svg>
    ),
  },
  twitter: {
    label: 'X',
    color: '#000000',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  facebook: {
    label: 'Facebook',
    color: '#1877f2',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  spotify: {
    label: 'Spotify',
    color: '#1db954',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
  },
  website: {
    label: 'Website',
    color: '#6c757d',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
};

const IdentifyPanel = ({ identifyState, artistLinksState, currentStation, onDismiss, onRetry, onOpenLyrics }) => {
  const isLoading = identifyState === 'loading';
  const result    = identifyState && identifyState !== 'loading' ? identifyState : null;

  if (!isLoading && !result) return null;

  return (
    <>
      {/* Backdrop — click anywhere outside panel to close */}
      <div className="ip-backdrop" onClick={onDismiss} aria-hidden="true" />

      <aside className="identify-panel" role="dialog" aria-modal="true" aria-label="Song identification">
        {/* Header */}
        <div className="ip-header">
          <div className="ip-header-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="ip-shazam-icon">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.75 17.75v-2.5a.75.75 0 0 0-1.5 0v2.5a5.756 5.756 0 0 1-5-5.75 5.756 5.756 0 0 1 5-5.75V9a.75.75 0 0 0 1.5 0V6.25A5.756 5.756 0 0 1 17.75 12a5.756 5.756 0 0 1-5 5.75z"/>
            </svg>
            <span>Song Identification</span>
          </div>
          <button className="ip-close" onClick={onDismiss} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Now playing context */}
        {currentStation && (
          <div className="ip-context">
            <span className="ip-context-label">Listening to</span>
            <span className="ip-context-station">{currentStation.name}</span>
          </div>
        )}

        {/* Loading */}
        {isLoading && (
          <div className="ip-loading">
            <div className="ip-loading-ring">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.75 17.75v-2.5a.75.75 0 0 0-1.5 0v2.5a5.756 5.756 0 0 1-5-5.75 5.756 5.756 0 0 1 5-5.75V9a.75.75 0 0 0 1.5 0V6.25A5.756 5.756 0 0 1 17.75 12a5.756 5.756 0 0 1-5 5.75z"/>
              </svg>
            </div>
            <p className="ip-loading-text">Listening to the stream…</p>
            <p className="ip-loading-sub">Capturing audio and checking Shazam</p>
          </div>
        )}

        {/* Not found */}
        {result && !result.found && (
          <div className="ip-notfound">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <p className="ip-notfound-title">No match found</p>
            <p className="ip-notfound-sub">This track may not be in Shazam's database. Try again in a moment.</p>
            {onRetry && (
              <button className="ip-retry-btn" onClick={onRetry}>
                <RetryIcon /> Try Again
              </button>
            )}
          </div>
        )}

        {/* Found — rich result */}
        {result && result.found && (
          <div className="ip-result">
            {/* Hero: album art with background blur */}
            <div className="ip-hero" style={result.background ? { '--ip-bg': `url(${result.background})` } : {}}>
              {result.coverart && (
                <img className="ip-coverart" src={result.coverart} alt={result.title} />
              )}
            </div>

            {/* Song title & artist */}
            <div className="ip-track">
              <h2 className="ip-track-title">{result.title}</h2>
              <div className="ip-track-artist">
                {result.artist_avatar && (
                  <img className="ip-artist-avatar" src={result.artist_avatar} alt={result.artist} />
                )}
                <span className="ip-artist-name">{result.artist}</span>
                {result.artist_verified && (
                  <span className="ip-verified" title="Verified artist">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
                    </svg>
                  </span>
                )}
              </div>
            </div>

            {/* Metadata rows */}
            <div className="ip-meta-grid">
              {result.album && (
                <div className="ip-meta-row">
                  <span className="ip-meta-label">Album</span>
                  <span className="ip-meta-value">{result.album}</span>
                </div>
              )}
              {result.released && (
                <div className="ip-meta-row">
                  <span className="ip-meta-label">Released</span>
                  <span className="ip-meta-value">{result.released}</span>
                </div>
              )}
              {result.label && (
                <div className="ip-meta-row">
                  <span className="ip-meta-label">Label</span>
                  <span className="ip-meta-value">{result.label}</span>
                </div>
              )}
            </div>

            {/* Artist social links — progressive load from MusicBrainz */}
            {artistLinksState && (() => {
              if (artistLinksState === 'loading') {
                return (
                  <div className="ip-artist-links">
                    <p className="ip-artist-links-title">Artist Links</p>
                    <div className="ip-links-skeleton">
                      <span className="ip-skeleton-pill" />
                      <span className="ip-skeleton-pill" />
                      <span className="ip-skeleton-pill" />
                    </div>
                  </div>
                );
              }
              const available = Object.entries(SOCIAL_META).filter(([key]) => artistLinksState[key]);
              if (available.length === 0) return null; // hide entirely if nothing found
              return (
                <div className="ip-artist-links">
                  <p className="ip-artist-links-title">Artist Links</p>
                  <div className="ip-links-row">
                    {available.map(([key, meta]) => (
                      <a
                        key={key}
                        href={artistLinksState[key]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ip-social-btn"
                        style={{ '--social-color': meta.color }}
                        title={meta.label}
                      >
                        {meta.icon}
                        <span>{meta.label}</span>
                      </a>
                    ))}
                  </div>
                </div>
              );
            })()}

            {/* Action buttons */}
            <div className="ip-actions">
              {result.shazam_url && (
                <a
                  href={result.shazam_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ip-action-btn ip-btn-shazam"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.75 17.75v-2.5a.75.75 0 0 0-1.5 0v2.5a5.756 5.756 0 0 1-5-5.75 5.756 5.756 0 0 1 5-5.75V9a.75.75 0 0 0 1.5 0V6.25A5.756 5.756 0 0 1 17.75 12a5.756 5.756 0 0 1-5 5.75z"/>
                  </svg>
                  Open in Shazam
                </a>
              )}
              {result.apple_music_url && (
                <a
                  href={result.apple_music_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ip-action-btn ip-btn-apple"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  Open in Apple Music
                </a>
              )}
              {onOpenLyrics && result.title && result.artist && (
                <button
                  className="ip-action-btn ip-btn-lyrics"
                  onClick={() => onOpenLyrics({ artist: result.artist, title: result.title })}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                    <line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
                  </svg>
                  View Lyrics
                </button>
              )}
              {onRetry && (
                <button className="ip-action-btn ip-btn-retry" onClick={onRetry}>
                  <RetryIcon /> Identify Again
                </button>
              )}
            </div>
          </div>
        )}
      </aside>
    </>
  );
};

export default IdentifyPanel;
